import React from 'react';
import Input from '../-FormControl';
import NewDnd from './Dnd';
import ListItem from './ListItem';
export default class SettingSideBoxContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayData: props.leftData, //左侧待选列显示模板
            sortData: props.rightData, //被选择排序的列显示模板
            json: {}, // 多语
        };
    }
    handleInputChange = (direction, value) => {
        switch (direction) {
            case 'left':
                this.setState({ leftKeyWord: value }, () => {
                    if (value) {
                        let searchFirstResult = document.querySelector('.TableColumnContent-left .selectBykeyword');
                        searchFirstResult && searchFirstResult.scrollIntoView();
                    }
                    //  else {
                    //     document.querySelector('.TableColumnContent-left').scrollTop = 0;
                    // }
                });
                break;
            case 'right':
                this.setState({ rightKeyWord: value }, () => {
                    if (value) {
                        let searchFirstResult = document.querySelector('.TableColumnContent-right .selectBykeyword');
                        searchFirstResult && searchFirstResult.scrollIntoView();
                    }
                    //  else {
                    //     document.querySelector('.TableColumnContent-right').scrollTop = 0;
                    // }
                });
                break;
            default:
                break;
        }

    }
    render() {
        let { json, leftData, rightData } = this.props;
        let { leftKeyWord, rightKeyWord } = this.state;
        return (
            <div
                className="settingSideBoxContainer"
            >
                <div className="settingSideBox-left-box">
                    <h3 className="settingSideBox-title">
                        <span>
                            {json['table_colseting_waitadd']}
                            {/*待添加*/}
                        </span>
                        <span className="settingSideBox-title-search">
                            <Input
                                value={leftKeyWord}
                                type="search"
                                placeholder={json['table_colseting_placeholder']}
                                onChange={this.handleInputChange.bind(this, 'left')}
                                onSearch={this.handleInputChange.bind(this, 'left')}
                                clearSearch={this.handleInputChange.bind(this, 'left', '')}
                            />
                        </span>
                    </h3>
                    <ul className="settingSideBox-left">
                        {leftData.map((val, i) => {
                            return (
                                // 左侧显示待选字段 showItem 为true
                                val.showItem && <ListItem 
                                    key={val.attrcode} 
                                    keyWord={leftKeyWord}
                                    item={val} 
                                />
                            );
                        })}
                    </ul>
                </div>
                <div className="settingSideBox-right-box">
                    <h3 className="settingSideBox-title">
                        <span>
                            {json['table_colseting_readyadd']}
                            {/*已添加*/}
                        </span>
                        <span className="settingSideBox-title-search">
                            <Input
                                value={rightKeyWord}
                                placeholder={json['table_colseting_placeholder']}
                                type="search"
                                onChange={this.handleInputChange.bind(this, 'right')}
                                onSearch={this.handleInputChange.bind(this, 'right')}
                                clearSearch={this.handleInputChange.bind(this, 'right', '')}
                            />
                        </span>
                    </h3>
                    <div className="settingSideBox-right">
                        <NewDnd
                            data={rightData}
                            onDragEnd={this.onDragEnd}
                            onStop={this.onDragEnd}
                            keyWord={rightKeyWord}
                        />
                    </div>
                </div>
            </div>
        )
    }
}